<template>
  <div class="col-xs-12  modal fade" id="addAddress" data-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content headlines-modal-wrapper container">
        <div class=" row modal-header m-0 scrollable-content">
          <div class="col-xs-12 col-sm-6 col-md-12 p-0 d-flex">
            <div  class="text-capitalize add-headline ">{{$t('addAddress')}}</div>
            <div class="cursor-pointer close-icon-outer" @click="cancelUpdateAddress()">
              <img class="pr-24" src="/static/images/icons/AddEditHeadline_Close_Icon.svg" />
            </div>
          </div>
          <div class="col-xs-12 p-0 header-line"><hr/></div>
          <div class="pt-17 pr-28 box-wrapper pl-32">
        <div class="col-sm-12 col-xs-12 pl-0 pr-0" :class="{'mb-36':!$v.companyData.streetAddress.$error && !$v.companyData.city.$error}">
          <div class="col-sm-6 col-md-6 col-xs-12 pl-0 pr-0 form-group" >
            <div class="col-sm-12 col-xs-12 p-0 form_label_name asterisk">{{ $t('streetAddress')}}</div>
            <div class="col-sm-12 col-xs-12 pl-0 field-section right pr-16">
              <input
                type="text"
                :placeholder="$t('enterStreetAddress')"
                class="form-control"
                size="60"
                v-model.trim="companyData.streetAddress"
                name="streetAddress"
                maxlength="500"
                @keyup="checkUpdatedFields($event)"
                :class="$v.companyData.streetAddress.$error ? 'invalid-border' : ''"
                @blur="$v.companyData.streetAddress.$touch()"
              />
              <div v-if="$v.companyData.streetAddress.$error">
                <div
                  class="custom-error-text"
                  v-if="!$v.companyData.streetAddress.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-text"
                  v-if="!$v.companyData.streetAddress.isAllowedCharacters && $v.companyData.streetAddress.$error"
                >{{ specialCharacterErrMsg }}</div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xs-12 p-0 form-group">
            <div class="col-sm-12 col-xs-12 form_label_name asterisk ml-22">{{$t('city')}}</div>
            <div class="col-sm-12 col-xs-12  field-section left pr-0">
              <input
                type="text"
                :placeholder="$t('enterCity')"
                class="form-control"
                maxlength="50"
                size="60"
                v-model.trim="companyData.city"
                name="city"
                @keyup="checkUpdatedFields($event)"
                :class="$v.companyData.city.$error ? 'invalid-border' : ''"
                @blur="$v.companyData.city.$touch()"
              />
              <div v-if="$v.companyData.city.$error">
                <div
                  class="custom-error-text"
                  v-if="!$v.companyData.city.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-text"
                  v-if="!$v.companyData.city.minLength"
                >{{$t('min3CharactersRequired')}}.</div>
                <div
                  class="custom-error-text"
                  v-else-if="!$v.companyData.city.isAllowedCharacters"
                >{{ specialCharacterErrMsg }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xs-12 pl-0 pr-0" :class="{'mb-36':!$v.companyData.state.$error && !$v.companyData.postCode.$error}">
          <div class="col-sm-6 col-md-6 col-xs-12 pl-0 form-group" >
            <div class="col-sm-12 col-xs-12 p-0 form_label_name asterisk">{{$t('state')}}</div>
            <div class="col-sm-12 col-xs-12 pl-0 field-section right pr-16">
              <input
                type="text"
                :placeholder="$t('enterState')"
                class="form-control"
                maxlength="50"
                size="60"
                v-model.trim="companyData.state"
                name="state"
                @keyup="checkUpdatedFields($event)"
                :class="$v.companyData.state.$error ? 'invalid-border' : ''"
                @blur="$v.companyData.state.$touch()"
              />
              <div v-if="$v.companyData.state.$error">
                <div
                  class="custom-error-text"
                  v-if="!$v.companyData.state.required"
                >{{$t('completeRequiredField')}}</div>
                <!-- <div
                  class="custom-error-text"
                  v-if="!$v.companyData.state.isAllowedCharacters && $v.companyData.state.$error"
                >{{ specialCharacterErrMsg }}</div> -->
                <div
                          class="custom-error-text"
                          v-if="!$v.companyData.state.isText && $v.companyData.state.$error && $i18n.locale === 'Portuguese'"
                        >Formato Inválido</div>
                        <div
                          class="custom-error-text"
                          v-if="!$v.companyData.state.isText && $v.companyData.state.$error && $i18n.locale === 'English'"
                        >Invalid format</div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xs-12 p-0 form-group">
            <div class="col-sm-12 col-xs-12  form_label_name ml-22">{{$t('postCode')}}</div>
            <div class="col-sm-12 col-xs-12 field-section left pr-0">
              <input
                type="text"
                :placeholder="$t('enterPostCode')"
                class="form-control"
                maxlength="15"
                v-model.trim="companyData.postCode"
                name="postCode"
                @keyup="checkUpdatedFields($event)"
                :class="$v.companyData.postCode.$error ? 'invalid-border' : ''"
                @blur="$v.companyData.postCode.$touch()"
              />
              <div v-if="$v.companyData.postCode.$error">
                <!-- <div
                  class="custom-error-text"
                  v-if="!$v.companyData.postCode.required"
                >{{$t('completeRequiredField')}}</div> -->
                <div
                  class="custom-error-text"
                  v-if="!$v.companyData.postCode.minLength"
                >{{$t('min2CharactersRequired')}}.</div>
                <div
                  class="custom-error-text"
                  v-else-if="!$v.companyData.postCode.isPostalCode && companyData.postCode"
                >{{$t('validZipRequired')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xs-12  pl-0 pr-0" :class="{'mb-36':!$v.companyData.country.$error}">
          <div class="col-sm-6 col-md-6 col-xs-12 pl-0 form-group" >
            <div class="col-sm-12 col-xs-12 p-0 form_label_name asterisk">{{$t('country')}}</div>
            <div class="col-sm-12 col-xs-12 pl-0 field-section right pr-16">
              <multiselect
                class="multiselect-single-dropdown mb-38"
                :placeholder="$t('selectACountry')"
                label="country_name"
                :showLabels="false"
                openDirection="below"
                v-model="companyData.country"
                :options="countryList.map(type => type.country_name)"
                :custom-label="opt => customLabels(opt)"
              >
              <span slot="noResult">{{ $t('noElementsFound') }}</span>
              </multiselect>
              <div v-if="$v.companyData.country.$error">
                <div
                  class="custom-error-text pt-48"
                  v-if="!$v.companyData.country.required && $v.companyData.country.$error"
                >{{$t('completeRequiredField')}}</div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div class="col-xs-12 p-0 d-flex justify-content-end col-gap-24 footer-buttons pr-24">
          <button type="button" class="btn  cancel_button" @click="cancelUpdateAddress()">{{$t('cancel')}}</button>
                  <button
                   @click="addAddress()"
                    type="button"
                    class="save_changes_button"
                    :disabled="disableSaveButton"
                  >{{$t('save')}}</button>
          </div>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>

  </div>
</template>

<script>
import $ from 'jquery';
import { isEqual } from 'lodash';
import { required, minLength } from 'vuelidate/lib/validators';
import { isAllowedCharacters, isPostalCode, isText } from '../Register/validator';
import { getAllCountries } from '../../apis/countriesList';
import { addAddress } from '../../apis/multiplantAddress';
import Loader from '../UIComponents/Loader.vue';

export default {
  data() {
    return {
      countryList: [],
      loaderStatus: false,
      disableSaveButton: true,
      currentTargetedField: '',
      companyData: {
        streetAddress: '',
        city: '',
        state: '',
        postCode: '',
        country: '',
      },
      specialCharacterErrMsg: 'The following characters are not allowed: * ? < > ! @ # $ “ % ^',
    };
  },
  validations: {
    companyData: {
      streetAddress: {
        required,
        isAllowedCharacters,
      },
      city: {
        minLength: minLength(3),
        required,
        isAllowedCharacters,
      },
      state: {
        required,
        isText,
        // isAllowedCharacters,
      },
      postCode: {
        minLength: minLength(2),
        isPostalCode,
      },
      country: {
        required,
      },
    },
  },
  components: {
    Loader,
  },
  methods: {
    cancelUpdateAddress() {
      this.$emit('updateManufacturingAddress');
      $('#addAddress').modal('hide');
    },

    async addAddress() {
      this.loaderStatus = true;
      const result = await addAddress(this.companyData);
      if (result.status_code === 200) {
        this.loaderStatus = false;
        this.clearNotifications();
        const validationMessage = this.$i18n.locale === 'Portuguese' ? 'O endereço foi adicionado com sucesso.' : 'Address was successfully added.';
        this.$emit('updatePlantLocation');
        $('#addAddress').modal('hide');

        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: validationMessage,
          group: 'custom-notification',
        });
      } else {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: result.data,
          group: 'custom-notification',
        });
      }
    },
    customLabels(opt) {
      const option = this.countryList.find((x) => x.country_name === opt);
      if (option && Object.keys(option) && Object.keys(option).length) {
        return option.country_name;
      }
      return '';
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },

    checkUpdatedFields(event) {
      if (event.currentTarget) {
        this.currentTargetedField = event.currentTarget.name;
      } else if (event === 'country_name') {
        this.currentTargetedField = this.companyData.country;
      }
      if (this.companyData.streetAddress === '' || this.companyData.city === '' || this.companyData.state === ''
         || this.companyData.country === '') {
        this.disableSaveButton = true;
        return;
      }

      if (this.$v.companyData.$invalid || !this.companyData.country) {
        this.disableSaveButton = true;
        return;
      }
      if (!isEqual(this.formData, this.companyData)) {
        this.disableSaveButton = false;
        return;
      }
      this.disableSaveButton = true;
    },

  },
  watch: {
    'companyData.country'() { //eslint-disable-line
      this.checkUpdatedFields('country_name');
    },
  },
  async created() {
    this.loaderStatus = true;
    this.countryList = await getAllCountries();
    this.loaderStatus = false;
  },
};
</script>

<style scoped>

.add-headline {
  font-weight: 600;
  font-size: 20px;
  color: #1A1A1A;
  padding: 19px 0 0 16px;
}

.cancel_button , .save_changes_button{
    padding:10px 16px  !important;
    border:none
  }

.modal-header .close {
  background: unset;
  opacity: 1;
  line-height: unset;
  width: unset;
  border-radius: unset;
  color: unset;
  font-weight: 300;
  font-size: 30px;
}

.modal-header .close {
  background: unset;
  opacity: 1;
  line-height: unset;
  width: unset;
  border-radius: unset;
  color: unset;
  font-weight: 300;
  font-size: 30px;
}

.box-wrapper {
  overflow: auto;
  margin-bottom: 10px;
  max-height: calc(70vh - 180px);
  overflow-y: auto;
  overflow-x: hidden;
  /* padding-right: 5px; */
}
.box-wrapper::-webkit-scrollbar {
  width: 6px;
}
.box-wrapper::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
  height: 30%;
}
.box-wrapper::-webkit-scrollbar-track-piece:end {
  margin-bottom: 20px;
}
.box-wrapper::-webkit-scrollbar-track-piece:start {
  margin-top: 20px;
}

.pt-17 {
 padding-top:17px
}

.pl-11{
  padding-left:11px
}
.pl-32{
  padding-left:32px

}
.pr-28 {
  padding-right: 28px;
}

.form-group{
  /* padding-left: 0px; */
  padding-right: 0px;
  margin-bottom: 0px !important;
}
.form-group ::placeholder {
  color:#999999;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px !important;
}

.form-group input{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #4d4d4d;
  padding-left: 11px;
  padding-top: 5px;
  padding-bottom: 5px;
  border: 1px solid #4D4D4D;
  border-radius: 3px;
  display: block;
  width: 100%;
  height: 34px;
}
.asterisk:after {
    content: '*';
    font-size: 16px;
    color: #C02032;
    position: relative;
    top: -1px;
    margin-left: 2px;
}
/* Country Multiselect Styles */
.multiselect-single-dropdown >>> .multiselect__option:hover {
  border:1px solid #0A99ff !important;
}
.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
  cursor: not-allowed;
}

.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 34px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 34px;
    /* padding: 9px 40px 11px 11px; */
    padding: 3px 40px 6px 11px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 7px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top: 4px !important;
        cursor: not-allowed;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;
        cursor: not-allowed;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    position: relative;
    right: 0;
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected span{
    /* font-weight: 600 !important; */
  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #CCCCCC !important;
    opacity:0.5;
    width: 95%;
  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #999999;
    overflow: visible;
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
     padding-left:4px !important;
  }
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 4px 40px 4px 12px;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    padding-top: 1px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }

  /* Footer buttons section  */
  .footer_buttons {
  position: absolute;
  bottom: 0px;
  right: 0px;
  padding:10px 0px 24px 24px;
  }
  .footer_left_button{
  display: flex;
  /* padding-left:30px; */
  align-items: center;
  justify-content: flex-start;
  z-index: 100;
  padding-top: 10px;
}
.footer_right_buttons_section{
  display:flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 16px;
  background: #ffffff;
  padding-top: 10px;
  padding-right: 24px;
}

.footer_right_buttons_section button:disabled{
  cursor: not-allowed;
  opacity: 0.5;
}

.pr-24{
  padding-right: 24px;
}
.close-icon-outer{
  position: absolute;
  right: -10px;
  top: 19px;
}
.modal-open .modal {
  overflow: hidden;
}

.modal-main {
  width:60%;
  margin-top: 10px;
}

.modal .modal-dialog .modal-content .modal-header {
  background: #FFFFFF;
  border-radius: 8px;
}

.modal-header {
  padding: 0px;
  border-bottom: 0px;
}
.container {
  /* position: absolute; */
  left: 0px;
  right: 0px;
  display: flex;
  flex-direction: column;
  max-height: calc(88vh - 10px);
  padding-left: 256px;
  padding-right: 0px;
  /* margin-top: 269px; */
}

.scrollable-content {
  flex-grow: 1;
  overflow: auto;
  overflow-x: hidden;
  min-height: 0;
  /* padding-left: 32px; */
}

.scrollable-content::-webkit-scrollbar {
  width: 6px;
  /* margin-left: 20px; */
}

.scrollable-content::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;

}

.headlines-modal-wrapper {
  width: 944px;
  /* padding: 24px 0px 0px 24px; */
  padding: 0px;
  /* padding-right:2px */
}

.header-line {
 padding: 18px 0px 9px 0px;
}
.header-line hr{
  border-top: 0.7px solid #BDBDBD;
  margin: 0px;
}

.footer-line {
  padding: 10px 25px 0px 8px;
  margin-bottom: 23px;
}
.footer-line hr{
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  margin: 0px;
}

.footer-buttons {
  padding-bottom: 16px;
  padding-top: 16px;
  padding-right: 16px !important;
  background-color: #FAFAF9;
  min-height: 76px;
}

@media (min-width: 992px){
  .modal-lg {
    width: 900px !important;
  }
}

</style>
